import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppCollapse from "../../../component/app_collapse/app_collapse";
import { ReactComponent as UploadIcon } from "../../../../Upload.svg";
import DocumentBloc from "../../../../bloc/document_bloc";
import FormBloc from "../../../../bloc/forms_bloc";
import { toBase64 } from "../../../component/app_validation";
import AppModal from "../../../component/app_modal/app_modal";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import PDFViewer from "../../../component/pdf/mrtt_pdf_viewer";
import ProposalBloc from "../../../../bloc/mrtt_proposal_bloc";
import AppContentFieldItem3 from "../../../component/app_quotation_card/app_content_field3";
import AppSteps from "../../../component/app_steps/app_steps2";
import { Modal } from "antd";


class UploadDocuments extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            personalDetailsData: null,
            personalDetailsErrInd: null,
            mortgageDetailsErrInd: null,
            healthStatementErrInd: null,
            directCreditDetailsErrInd: null,
            idType: null,
            isOpenPDF: false,
            listDocuments: [],
            selectedDocument: [],
            hadDisease: false,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            isSuccessModalOpen: false,
            stepHeader: [
                {
                    title: 'Provide Details',
                    status: 'process'
                },
                {
                    title: 'Upload Documents',
                    status: 'process'
                },
                {
                    title: 'Review',
                    status: 'wait'
                },
                {
                    title: 'Consent and Declaration',
                    status: 'wait'
                },
            ],
        };
        this.getProposalData()
    }


    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    //set validation result for each section & control collapse background color
    handleChangePersonalDetailsErrInd(val) {
        this.setState({ personalDetailsErrInd: val });
    }
    handleChangeMortgageDetailsErrInd(val) {
        this.setState({ mortgageDetailsErrInd: val });
    }
    handleChangeHealthStatementErrInd(val) {
        this.setState({ healthStatementErrInd: val });
    }
    handleChangeDirectCreditDetailsErrInd(val) {
        this.setState({ directCreditDetailsErrInd: val });
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    async getProposalData() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let userSettings = await UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        let editable = await ProposalBloc.editGeneratedProposal(this.getProposalID());
        if (editable.success) {
            let result = await ProposalBloc.getProposalDetail(this.getProposalID(), userData.username);//'SHA002'
            if (result) {
                console.log("see document", result.generatedDocuments.data)
                this.setState({
                    listDocuments: result.generatedDocuments.data.filter((el) => (el.code === 'nric_front_back' || el.code === 'passport_copy' || el.code === 'police_identification')),
                    idType: result.personalDetails.idType.value,
                    docRequirement: result.documentRequirement
                })
            }
        } else {
            this.setState({
                loading: false,
                isOpen: true,
                title: 'Notification',
                description: 'This proposal cannot be edit or update.'
            })
        }
        this.setState({ loading: false });
    }

    initiateData() { }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    getProposalID() {
        return this.props.match.params.itemId;
    }

    getStatus() {
        return this.props.status;
    }

    stateModule() {
        return "quotation";
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    stateSelectedDocument() {
        return this.state.selectedDocument;
    }

    stateMaxFileUpload() {
        return this.state.docRequirement?.maxFileUpload ?? 0;
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleSuccessModalOpen = () => {
        this.setState({ isSuccessModalOpen: true })
    }
    handleSuccessModalClose = () => {
        this.setState({ isSuccessModalOpen: false })
    }

    handleGoBack = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${this.getProposalID()}`
    }

    handleStopWithoutSaving = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
    }

    handleSaveCurrentStep() {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
    }

    handleNextStep() {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_review}/${this.getProposalID()}`
    }

    async handleFormSubmit() {
        let documentData = {
            format: '',
            id: '',
            code: '',
            content: '',
        }
        let result = await ProposalBloc.uploadProposalDocument(documentData);
        this.handleSuccessModalOpen();
    }

    handleDeleteDocument(id) {
        this.setState({
            listDocuments: this.state.listDocuments.splice(id + 1, 1)
        })
    }

    openUpload(id) {
        if (this.isFileUploadNotExceed()) {
            document.getElementById("new-upload-file").click();
        }
    }

    handleMessageModalClose = () => {
        this.setState({ isOpen: false });
    }

    handleMessageModalOpen = () => {
        this.setState({ isOpen: true });
    }

    stateMaxSizeUploadByteFormat() {
        const maxSizeGB = this.state.docRequirement?.maxSizeGB;
        const maxSizeBytes =
            maxSizeGB !== null && maxSizeGB !== undefined
                ? maxSizeGB * Math.pow(1024, 3)
                : 0;

        return maxSizeBytes;
    }


    stateMaxSizeUploadMegaByteFormat() {
        return Math.round(this.state.docRequirement?.maxSizeGB * 1024 || 10);
    }

    isFileUploadNotExceed() {
        return this.state.listDocuments.length < this.stateMaxFileUpload();
    }

    openViewDialog(type, content, filename) {
        this.setState({
            isOpenPDF: true,
            type: type,
            content: content,
            pdfName: filename
        });
    }


    closeViewDialog() {
        this.setState({
            isOpenPDF: false,
        });
    }

    async viewOrDownloadFile(id, typeFile, filename) {
        this.setState({
            loading: true,
        });
        let content = '';
        let type = "";
        if (typeFile == "pdf") {
            type = "application";
        } else {
            type = "image";
        }
        let docPayload = { id: id };
        let downloadResult = await DocumentBloc.getMrttDocsById(
            "uploaded_document_file",
            docPayload
        );
        if (downloadResult.success) {
            content = `data:${type}/${typeFile};base64,${downloadResult.data[0]?.uploaded_document.content || ''}`;
            this.setState({
                loading: false,
            });
            this.openViewDialog(typeFile, content, filename);
        }
    }

    async onChangeFile(event) {
        this.setState({
            loading: true,
        });

        let selectedDocument = this.stateSelectedDocument();
        let file = event.target.files[0];
        let filename = "" + file.name;
        let fileType = file.type;
        fileType = fileType.split("/")[1];
        FormBloc.checkFileNameExtension(filename);
        let fileSize = file.size;
        // let base64data = await toBase64(file, this.stateMaxSizeUploadByteFormat());
        if (fileSize > 10000000) { //this.stateMaxSizeUploadByteFormat()
            this.setState({
                isOpen: true,
                description: `Upload failed. File cannot exceed ${10} MB.`,
                title: 'Notification',
                loading: false,
            });
            event.target.value = "";
            return;
        }
        let strImage = await toBase64(file);
        let binaryCode = strImage.split("base64,")[1];

        let docPayload = [
            {
                reference1: fileType ? fileType.toUpperCase() : "PDF",
                reference2: this.getProposalID(),
                documentCode:
                    this.state.idType == 'IC' ? 'nric_front_back' :
                        this.state.idType == 'Police/Army' ? 'police_identification' : 'passport_copy',
                content: binaryCode
            },
        ];
        let uploadResult = await ProposalBloc.uploadProposalDocument(docPayload);

        if (uploadResult.success) {
            event.target.value = "";
            await this.getProposalData();
            this.setState(
                {
                    loading: false,
                },
                () => {
                    this.setState({
                        isOpen: true,
                        description: 'File upload success',
                        title: 'Notification',
                    });
                }
            );
        } else {
            this.setState({
                loading: false,
            });
            event.target.value = "";
        }
    }

    async deleteUploadDocsById(id) {
        this.setState({ loading: true });
        let deleteResult = await ProposalBloc.deleteUploadedDocumentById({ id: id });
        if (deleteResult.success) {
            await this.getProposalData();
            this.setState(
                {
                    loading: false,
                },
                () => {
                    this.setState({
                        isOpen: true,
                        description: 'File deleted success',
                        title: 'Notification',
                    });
                }
            );
        } else {
            this.setState({
                loading: false,
            });
        }
    }

    getNewOrUploaded(file, index) {
        let document = file.document;
        let uploaded_document = file?.uploaded_document;
        let properties = "";
        let reference1 = "";
        if (uploaded_document && uploaded_document.status) {
            properties = uploaded_document.properties;
            reference1 = uploaded_document.reference1;
        }
        let content = null;
        if (uploaded_document && uploaded_document.documentCode != null) {
            content = (
                <AppContentFieldItem3
                    title={properties.filename}
                    value={`${properties.sizeMB} MB`}
                    status={"Uploaded"}
                    size={properties.sizeMB}
                    type={file.type}
                    borderless={this.props.borderless || false}
                    showDeleteIcon={!this.propViewOnly() ? true : false}
                    onView={(id) => {
                        this.viewOrDownloadFile(
                            uploaded_document.id,
                            reference1?.toLowerCase()
                        );
                    }}
                    onDelete={(id) => {
                        this.deleteUploadDocsById(uploaded_document.id);
                    }}
                />
            );
        } else {
            content = (
                <AppContentFieldItem3
                    title={file.filename}
                    value={`${file.size} MB`}
                    status={"Uploaded"}
                    size={Number(file.size).toFixed(2)}
                    type={file.type}
                    borderless={this.props.borderless || false}
                    showDeleteIcon={true}
                    onView={(id) => {
                        this.viewOrDownloadFile(
                            file.value,
                            file.type?.toLowerCase(),
                            file.filename
                        );
                    }}
                    onDelete={(id) => {
                        this.deleteUploadDocsById(file.value);
                    }}
                />
            );
        }

        return content;
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={this.state.listDocuments.length > 0}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }


    renderSampleDocument = async (documenttype) => {
        let imageUrl = '';
        if (documenttype === 'ic') {
            imageUrl = GeneralBloc.getAssetsContextPath() +
                `/assets/images/Illustration/ic_sample.jpeg`;
        } else if (documenttype === 'police/army') {

        } else {
            imageUrl = GeneralBloc.getAssetsContextPath() +
                `/assets/images/Illustration/passport_sample.jpeg`;
        }
        if (imageUrl) {

            this.setState({
                exampleModalOpen: true,
                type: 'image',
                contentUrl: imageUrl,
                pdfName: documenttype + '_sample'
            });
        }
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                        this.getProposalData();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%', height: 50 }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={0}
                                    items={this.state.stepHeader}
                                />
                            </div>

                        </App_header>
                        {this.state.loading && this.loadingContent()}
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150,
                                fontFamily: 'Lato'
                            }}
                        >

                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={Config.proposal.formStepData[1].header}
                                    description={Config.proposal.formStepData[1].subheader}
                                    handleBack={() => this.handleGoBack()}
                                />
                            </div>
                            <div className="w-100 my-2 d-flex row" >
                                <div className="w-100 px-4 py-3" style={{ fontFamily: 'Lato' }}>
                                    <div className="row d-flex">
                                        <div className="col-lg-6 col-sm-12">
                                            <div className="upload_documents_instruction_header">To ensure a smooth process, please exercise the following when submitting your documents:</div>
                                            <ul className="" style={{ listStyleType: 'disc', paddingLeft: '1vw', paddingTop: '1vh' }}>
                                                <li>
                                                    You can upload a copy of your documents in the form of PDF, PNG, JPG or JPEG files.
                                                </li>
                                                <li>
                                                    Ensure each file document is smaller than 10MB.
                                                </li>
                                                <li>
                                                    Ensure that the photograph is taken from directly above looking down the document.
                                                </li>
                                                <li>
                                                    Ensure that all information is visible and not blurry so that it can be read.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-lg-6 col-sm-12 d-flex">
                                            <img
                                                src={
                                                    GeneralBloc.getAssetsContextPath() +
                                                    `/assets/images/Illustration/Document1.png`
                                                }
                                                alt="Documents"
                                                className="mr-3 example_upload_document"
                                            />
                                            <img
                                                src={
                                                    GeneralBloc.getAssetsContextPath() +
                                                    `/assets/images/Illustration/Document2.png`
                                                }
                                                alt="Documents"
                                                className="example_upload_document"
                                            />
                                        </div>
                                    </div>
                                    <div className="upload_documents_instruction_header mt-2">
                                        Please upload the relevant supporting documents to this proposal. You can only upload 1 document at a time.
                                    </div>
                                    <div className="documents_header my-4">
                                        Mandatory Documents
                                    </div>
                                    <AppCollapse
                                        header={
                                            <div className="d-flex justify-content-between">
                                                {this.state.idType == 'IC' ?
                                                    'Identity Card (Front and back)' : this.state.idType == 'Police/Army' ? 'Police Identification Card' : 'Passport'
                                                }
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.openUpload();
                                                    }}
                                                >
                                                    <input
                                                        onChange={(e) => this.onChangeFile(e)}
                                                        id={"new-upload-file"}
                                                        type="file"
                                                        accept="image/jpeg,image/png,application/pdf"
                                                        style={{ display: "none" }}
                                                    />
                                                    <UploadIcon />
                                                </div>

                                            </div>}
                                        backgroundColor={'#FAFAFA'}
                                        borderEnable={false}
                                        expand={'0'}
                                    >
                                        <div className="see_example"
                                            onClick={() =>
                                                this.renderSampleDocument(this.state.idType == 'IC' ? 'ic' :
                                                    this.state.idType == 'Police/Army' ? 'police/army' : 'passport'
                                                )}
                                        >
                                        </div>

                                        <div className="mt-3">
                                            {this.state.listDocuments && this.state.listDocuments.map((item, id) => {
                                                return this.getNewOrUploaded(item, id)
                                            })
                                            }
                                        </div>

                                    </AppCollapse>
                                    {this.renderBottomBar()}
                                    <AppModal
                                        open={this.state.isSaveModalOpen}
                                        handleModalClose={this.handleSaveModalClose}
                                        width={'50%'}
                                        title={'Do you want to stop?'}
                                        subtitle={'If you stop without saving, you will loose any progress you\'ve made.'}
                                        negativeButtonText={'Stop without Saving'}
                                        positiveButtonText={'Save & Close'}
                                        handleNegativePress={() => this.handleStopWithoutSaving()}
                                        handlePositivePress={() => this.handleSaveCurrentStep()}
                                        closable={false}
                                    />
                                    <AppModal
                                        open={this.state.isDiscardModalOpen}
                                        handleModalClose={this.handleDiscardModalClose}
                                        width={'50%'}
                                        title={'Do you want to discard?'}
                                        subtitle={'If you discard without saving, you will loose any progress you\'ve made.'}
                                        negativeButtonText={'Stop without Saving'}
                                        positiveButtonText={'Save & Close'}
                                        handleNegativePress={() => this.handleStopWithoutSaving()}
                                        handlePositivePress={() => this.handleSaveCurrentStep()}
                                        closable={false}
                                    />
                                    <AppModal
                                        open={this.state.isOpen}
                                        handleModalClose={() => this.handleMessageModalClose()}
                                        width={'50%'}
                                        title={this.state.title}
                                        subtitle={this.state.description}
                                        positiveButtonText={'Close'}
                                        handlePositivePress={() => this.handleMessageModalClose()}
                                        closable={false}
                                    />
                                    <Modal
                                        open={this.state.exampleModalOpen}
                                        onCancel={() => this.setState({ exampleModalOpen: false })}
                                        footer={null}
                                        width={'70%'}
                                        closable={false}
                                    >
                                        <div className="justify-content-between d-flex text_outside_modal mb-2" >
                                            {this.state.pdfName}
                                            {/* <div style={{ cursor: 'pointer' }} onClick={() => handleDownload()}><DownloadIcon fill={'#FFFFFF'} /></div> */}
                                        </div>
                                        <div className="col-md-12 text-left">
                                            <div className="w-100 d-flex justify-content-center">
                                                <img className="img-fluid" style={{ objectFit: "contain", minHeight: '70vh' }}
                                                    src={this.state.contentUrl} alt="sample"
                                                />
                                            </div>
                                        </div>
                                    </Modal>
                                    <PDFViewer
                                        open={this.state.isOpenPDF}
                                        title={this.state.pdfName}
                                        handleModalClose={() => this.closeViewDialog()}
                                        width={'70%'}
                                        content={this.state.content}
                                        closable={false}
                                        showDownload={true}
                                        document={this.state.type}
                                    />


                                    {/* <TermsAndConditionDialog
                                showClose={true}
                                isOpen={this.state.isOpenPDF}
                                content={this.state.pdfContent || null}
                                onDialogClose={(e) => this.closeViewDialog()}
                                type={this.state.type}
                                name={this.state.pdfName}
                                showDownload={true}
                            /> */}
                                </div>
                            </div>

                        </div>
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(UploadDocuments));
